<div
  class="side-nav-shell"
  [class.expanded]="mode === 'expanded'"
  [class.collapsed]="mode === 'collapsed'"
>
  <div class="side-nav">
    <app-side-nav-expanded
      [compact]="mode === 'collapsed'"
      (logout)="logout()"
    />
  </div>

  <button
    type="button"
    class="side-nav-toggle-tab"
    (click)="toggleNav()"
    [attr.aria-label]="
      mode === 'expanded'
        ? 'Collapse side navigation'
        : 'Expand side navigation'
    "
  >
    <i
      class="bi"
      [class.bi-chevron-double-left]="mode === 'expanded'"
      [class.bi-chevron-double-right]="mode === 'collapsed'"
      aria-hidden="true"
    ></i>
  </button>
</div>
